export const GET_FUNDING_REPORT = "GET_FUNDING_REPORT";
export const GET_FUNDING_REPORT_SUCCESS = "GET_FUNDING_REPORT_SUCCESS";
export const GET_FUNDING_REPORT_FAIL = "GET_FUNDING_REPORT_FAIL";
